import { SortDescriptor } from '@progress/kendo-data-query'
import { TradingAccountFilterKey, TradingAccountKey } from 'api/Clients/Types/TradingAccount'

export const normalizeTradingAccountsSortQuery = (
  sortDescriptors: SortDescriptor[]
): SortDescriptor[] =>
  sortDescriptors
    .map((x) => {
      if (x.field === TradingAccountKey.name) {
        return { ...x, field: TradingAccountFilterKey.name }
      }
      if (x.field === TradingAccountKey.clientName) {
        return { ...x, field: TradingAccountFilterKey.client }
      }
      if (x.field === TradingAccountKey.introducingBrokerName) {
        return { ...x, field: TradingAccountFilterKey.introducingBroker }
      }
      if (x.field === TradingAccountKey.accountGroupName) {
        return { ...x, field: TradingAccountFilterKey.accountGroup }
      }
      if (x.field === TradingAccountKey.accountGroupTypeName) {
        return { ...x, field: TradingAccountFilterKey.accountGroupType }
      }
      if (x.field === TradingAccountKey.walletName) {
        return { ...x, field: TradingAccountFilterKey.wallet }
      }
      if (x.field === TradingAccountKey.accountTypeName) {
        return { ...x, field: TradingAccountFilterKey.accountType }
      }
      if (x.field === TradingAccountKey.currencyId) {
        return { ...x, field: TradingAccountFilterKey.currency }
      }
      if (x.field === TradingAccountKey.statusName) {
        return { ...x, field: TradingAccountFilterKey.status }
      }
      if (x.field === TradingAccountKey.countryName) {
        return { ...x, field: TradingAccountFilterKey.country }
      }
      if (x.field === TradingAccountKey.tickmillCompanyName) {
        return { ...x, field: TradingAccountFilterKey.tickmillCompany }
      }
      if (x.field === TradingAccountKey.createdDate) {
        return { ...x, field: TradingAccountFilterKey.createdDate }
      }
      if (x.field === TradingAccountKey.updatedDate) {
        return { ...x, field: TradingAccountFilterKey.updatedDate }
      }
      return x
    })
    .filter((x) => !!x)
